import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCart } from '@cart/const';
import { ActiveCartService } from '@cart/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-prepayment',
  templateUrl: './prepayment.component.html',
  styleUrls: ['./prepayment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrePaymentComponent implements OnInit {
  iconType = CUSTOM_ICON_TYPE;

  prepaid$: Observable<boolean>;

  constructor(private activeCartService: ActiveCartService) {}

  ngOnInit(): void {
    this.prepaid$ = this.activeCartService.getActive().pipe(map((cart: CustomCart) => cart.isInflow));
  }
}
